var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'scrollbar '+_vm.type},[_c('div',{staticClass:"scrollbar-thumb",style:({width:(_vm.type=='vertical'?'100%':_vm.length+'px'),
  height:(_vm.type=='vertical'?_vm.length+'px':'100%'),left:(_vm.type=='vertical'?0:_vm.offset+'px'),
  top:(_vm.type=='vertical'?_vm.offset+'px':0)}),on:{"mousedown":function($event){$event.stopPropagation();return _vm.scrollbarMousedown.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }